import React from 'react';

const ArStep2_2 = ({ ...props }) => {
  return (
    <svg
      {...props}
      width="260"
      height="179"
      viewBox="0 0 260 179"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31" cy="17" r="17" fill="#ADB5BD" />
      <path
        d="M26.5076 40.5509C26.0669 33.8002 17.2538 32 15.0505 32C2.68245 32 1.39803 41.8397 0.517044 48.5889L0.508829 48.6518C-0.372488 55.4026 0.0681701 77.905 0.508829 84.2057C0.949487 90.5064 1.39015 90.9564 4.47476 95.4569C7.55936 99.9574 8.44068 117.959 8.88134 126.96C9.322 135.961 7.1186 148.113 6.23729 150.813C5.35597 153.513 0.0680687 171.065 13.2878 171.965C26.5076 172.865 28.7109 156.214 27.8296 126.96C26.9482 97.7072 21.6603 95.4569 24.7449 92.3066C27.8296 89.1562 26.5076 78.8863 26.5076 73.8546V50.9021C26.5076 49.1019 26.9482 47.3017 26.5076 40.5509Z"
        fill="#ADB5BD"
      />
      <mask
        id="mask0_687_6584"
        maskUnits="userSpaceOnUse"
        x="0"
        y="32"
        width="28"
        height="140"
      >
        <path
          d="M26.5076 40.5509C26.0669 33.8002 17.2538 32 15.0505 32C2.68245 32 1.39803 41.8397 0.517044 48.5889L0.508829 48.6518C-0.372488 55.4026 0.0681701 77.905 0.508829 84.2057C0.949487 90.5064 1.39015 90.9564 4.47476 95.4569C7.55936 99.9574 8.44068 117.959 8.88134 126.96C9.322 135.961 7.1186 148.113 6.23729 150.813C5.35597 153.513 0.0680687 171.065 13.2878 171.965C26.5076 172.865 28.7109 156.214 27.8296 126.96C26.9482 97.7072 21.6603 95.4569 24.7449 92.3066C27.8296 89.1562 26.5076 78.8863 26.5076 73.8546V50.9021C26.5076 49.1019 26.9482 47.3017 26.5076 40.5509Z"
          fill="#ADB5BD"
        />
      </mask>
      <g mask="url(#mask0_687_6584)">
        <path
          d="M11.7881 49.0331L27.5304 69.5233L27.9317 75.929L24.2964 79.584L13.1465 71.3324L10.8012 53.9431L11.7881 49.0331Z"
          fill="url(#paint0_linear_687_6584)"
        />
      </g>
      <rect
        width="18"
        height="4"
        rx="2"
        transform="matrix(0.809185 -0.587554 0.588017 0.808849 61.083 59)"
        fill="#33415C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.9404 72.5843C29.3835 72.2067 28.8812 71.7286 28.4619 71.1545L11.3577 47.7355C9.40333 45.0595 9.99169 41.3105 12.6719 39.3618C15.3521 37.4132 19.1092 38.0028 21.0636 40.6788L36.7235 62.1204L59.1215 55.4889C62.034 54.6266 65.0972 56.2878 65.9631 59.1993C66.829 62.1108 65.1699 65.1701 62.2573 66.0325L35.4094 73.9815C33.4015 74.576 31.3222 73.9712 29.9404 72.5843Z"
        fill="#ADB5BD"
      />
      <line
        x1="38.5"
        y1="172.5"
        x2="249.5"
        y2="172.5"
        stroke="black"
        strokeLinecap="round"
      />
      <path
        d="M38.847 175.384L76.6851 58.5169C77.0938 57.2545 78.5962 56.7328 79.6994 57.4703L254.521 174.337C256.165 175.436 255.387 178 253.409 178H40.7498C39.3919 178 38.4287 176.676 38.847 175.384Z"
        fill="url(#paint1_linear_687_6584)"
        stroke="url(#paint2_linear_687_6584)"
        strokeLinecap="round"
        strokeDasharray="10 10"
      />
      <circle cx="158.5" cy="167.5" r="2.5" fill="#EF476F" />
      <circle cx="186.5" cy="159.5" r="2.5" fill="#EF476F" />
      <circle cx="97.5" cy="167.5" r="2.5" fill="#EF476F" />
      <circle cx="64.5" cy="162.5" r="2.5" fill="#EF476F" />
      <path
        d="M158.717 77.8872L152.496 87.4664L151.717 86.9601L157.295 78.3703L154.075 77.6485L154.556 76.9081L158.586 77.8021L158.717 77.8872ZM167.047 83.2498L167.158 83.3221L166.711 84.0101L166.6 83.9378C165.997 83.5463 165.396 83.2957 164.797 83.1859C164.202 83.0789 163.622 83.1061 163.057 83.2675C162.5 83.4274 161.969 83.7155 161.462 84.1318C160.956 84.5482 160.491 85.0818 160.069 85.7327L159.213 87.0497C158.927 87.4908 158.729 87.9244 158.62 88.3505C158.514 88.7721 158.486 89.1734 158.537 89.5541C158.588 89.9349 158.712 90.2794 158.909 90.5876C159.107 90.8958 159.367 91.1549 159.69 91.3648C160.009 91.5719 160.338 91.6922 160.676 91.7257C161.014 91.7591 161.348 91.7147 161.676 91.5923C162.008 91.4727 162.319 91.2898 162.609 91.0436C162.907 90.7959 163.171 90.4951 163.4 90.1413C163.619 89.805 163.781 89.4599 163.886 89.1062C163.999 88.7509 164.043 88.4007 164.019 88.0557C163.994 87.7108 163.894 87.3877 163.717 87.0864C163.54 86.7852 163.274 86.5197 162.921 86.2899C162.519 86.0289 162.083 85.8767 161.615 85.8332C161.146 85.7898 160.701 85.8486 160.28 86.0097C159.863 86.1736 159.53 86.4326 159.282 86.7866L158.834 86.4865C159.131 86.0957 159.465 85.7876 159.835 85.5621C160.208 85.3323 160.598 85.1853 161.006 85.1211C161.421 85.0555 161.837 85.0707 162.253 85.1668C162.676 85.2614 163.084 85.4363 163.477 85.6916C163.935 85.9895 164.281 86.332 164.514 86.7193C164.751 87.1094 164.889 87.5245 164.926 87.9646C164.97 88.4033 164.925 88.8495 164.792 89.3033C164.666 89.7555 164.467 90.1913 164.195 90.6106C163.897 91.0693 163.553 91.4548 163.164 91.7672C162.782 92.0781 162.37 92.3012 161.928 92.4365C161.491 92.5747 161.044 92.6133 160.586 92.5524C160.133 92.4942 159.689 92.3234 159.252 92.0397C158.771 91.7277 158.401 91.3565 158.14 90.9263C157.879 90.496 157.718 90.0313 157.657 89.5322C157.601 89.036 157.636 88.5313 157.764 88.0184C157.9 87.5039 158.124 87.0064 158.436 86.5259L158.98 85.6873C159.508 84.8748 160.08 84.1998 160.696 83.6622C161.315 83.1202 161.967 82.7331 162.652 82.501C163.341 82.2716 164.052 82.2147 164.784 82.3301C165.524 82.444 166.278 82.7506 167.047 83.2498ZM165.208 95.7211L164.428 95.2148L169.602 87.2474C169.917 86.7625 170.265 86.408 170.647 86.1838C171.033 85.9625 171.436 85.8674 171.857 85.8984C172.282 85.9323 172.711 86.0896 173.143 86.3705C173.278 86.4584 173.413 86.5579 173.545 86.669C173.681 86.7757 173.802 86.8949 173.909 87.0265L173.421 87.65C173.331 87.5485 173.233 87.4565 173.125 87.374C173.024 87.29 172.899 87.1997 172.751 87.1033C172.467 86.9189 172.183 86.8212 171.898 86.8102C171.616 86.7948 171.347 86.8652 171.09 87.0215C170.833 87.1777 170.597 87.4218 170.382 87.7537L165.208 95.7211ZM171.502 89.7295L171.085 90.3716L167.442 88.0058L167.859 87.3637L171.502 89.7295ZM175.59 92.3846L175.173 93.0267L171.622 90.7205L172.039 90.0784L175.59 92.3846ZM174.526 89.1037L175.306 89.61L170.638 96.7977C170.425 97.1253 170.309 97.4005 170.288 97.6232C170.268 97.8459 170.309 98.031 170.412 98.1786C170.515 98.3262 170.647 98.4524 170.809 98.5574C170.927 98.634 171.044 98.7012 171.162 98.759C171.283 98.8124 171.392 98.8588 171.491 98.898L171.094 99.5811C170.978 99.5492 170.838 99.4924 170.674 99.4106C170.507 99.3332 170.347 99.2448 170.194 99.1455C169.892 98.9498 169.661 98.7222 169.501 98.4626C169.343 98.1987 169.287 97.8888 169.331 97.5329C169.379 97.1726 169.556 96.7566 169.862 96.2848L174.526 89.1037Z"
        fill="#33415C"
      />
      <path
        d="M237.612 149.828L235.081 144.639L231.853 149.425L237.612 149.828ZM88.3855 49.1734L90.9165 54.3626L94.145 49.5761L88.3855 49.1734ZM227.717 142.551L220.934 137.976L220.375 138.805L227.158 143.38L227.717 142.551ZM214.151 133.4L207.368 128.825L206.809 129.654L213.592 134.229L214.151 133.4ZM200.585 124.25L193.802 119.675L193.243 120.504L200.026 125.079L200.585 124.25ZM187.019 115.099L180.236 110.524L179.677 111.353L186.46 115.929L187.019 115.099ZM173.453 105.949L166.67 101.374L166.111 102.203L172.894 106.778L173.453 105.949ZM159.887 96.7986L153.104 92.2234L152.545 93.0525L159.328 97.6277L159.887 96.7986ZM146.321 87.6482L139.538 83.073L138.979 83.902L145.762 88.4773L146.321 87.6482ZM132.755 78.4978L125.972 73.9226L125.413 74.7516L132.196 79.3268L132.755 78.4978ZM119.189 69.3474L112.406 64.7721L111.847 65.6012L118.63 70.1764L119.189 69.3474ZM105.623 60.1969L98.8397 55.6217L98.2805 56.4507L105.064 61.026L105.623 60.1969Z"
        fill="#33415C"
      />
      <defs>
        <linearGradient
          id="paint0_linear_687_6584"
          x1="19.079"
          y1="51.6675"
          x2="12.4563"
          y2="55.7428"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.107993" stopColor="#33415C" />
          <stop offset="0.89927" stopColor="#C4C4C4" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_687_6584"
          x1="76.0444"
          y1="53.6926"
          x2="89.9919"
          y2="175.299"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF476F" stopOpacity="0.4" />
          <stop offset="1" stopColor="#EF476F" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_687_6584"
          x1="149"
          y1="51"
          x2="149"
          y2="178"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#EF476F" />
          <stop offset="1" stopColor="#EF476F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default ArStep2_2;
